import React from 'react';

function DistrictPropertyBox({
    districtLink,
    districtImage,
    districtName,
    districtRentItems,
    districtSellItems,
    districtLeaseItems,
    onClick // Accept the onClick prop
}) {
    return (
        <div className="districtPropertyBox" onClick={onClick}>
            <img src={districtImage} alt={districtName} />
            <div className="districtPropertyBoxDetails">
                <h3>{districtName}</h3>
                <ul>
                    <li>
                        <h4>{districtRentItems}</h4>
                        <p>Rent</p>
                    </li>
                    <li>
                        <h4>{districtSellItems}</h4>
                        <p>Sell</p>
                    </li>
                    <li>
                        <h4>{districtLeaseItems}</h4>
                        <p>Lease</p>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default DistrictPropertyBox;
